import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Movement"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M18 15L16.9425 16.0575L19.6275 18.75H7.5C5.84315 18.75 4.5 17.4069 4.5 15.75C4.5 14.0931 5.84315 12.75 7.5 12.75H16.5C18.9853 12.75 21 10.7353 21 8.25C21 5.76472 18.9853 3.75 16.5 3.75H4.3725L7.0575 1.0575L6 0L1.5 4.5L6 9L7.0575 7.9425L4.3725 5.25H16.5C18.1569 5.25 19.5 6.59315 19.5 8.25C19.5 9.90685 18.1569 11.25 16.5 11.25H7.5C5.01472 11.25 3 13.2647 3 15.75C3 18.2353 5.01472 20.25 7.5 20.25H19.6275L16.9425 22.9425L18 24L22.5 19.5L18 15Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Movement.vue"]]);
